// extracted by mini-css-extract-plugin
export default {"component":"Services_component__9mN-l","main_text_info":"Services_main_text_info__DnlWI","main_services":"Services_main_services__yctCn"};